import script from "./machine-detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./machine-detail.vue?vue&type=script&setup=true&lang=ts"

import "./machine-detail.vue?vue&type=style&index=0&id=63f5e489&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f5e489"]])

export default __exports__